import type {Mapper} from 'framework';
import type {WorkoutTemplateSummary} from '../../domain/workout-template';
import type {WorkoutTemplateSummaryDto} from '../dto/workout.dto';

export class WorkoutTemplateSummaryDtoToSummaryMapper
  implements Mapper<WorkoutTemplateSummaryDto, WorkoutTemplateSummary>
{
  transform(dto: WorkoutTemplateSummaryDto): WorkoutTemplateSummary {
    return {
      id: dto.id,
      name: dto.name,
      notes: dto.notes,
      exerciseCount: dto.exerciseCount,
      createdAt: String(dto.createdAt),
      updatedAt: String(dto.updatedAt),
    };
  }
}
